import { Component } from 'react';

import { Row, Container, Col, Card } from 'react-bootstrap';


class ContactPage extends Component {

    img(title, src, className) {
        return <Card className={`img-card ${className}`}>
            <Card.Header>
                <Card.Title>{title}</Card.Title>
            </Card.Header>
            <Card.Body>
                <img alt={title} src={src} />
            </Card.Body>
        </Card>
    }

    render() {
        return (
            <Container className="contact-page" style={{width: 700, margin: "inherit auto"}}>
                <Row>
                    <Col>
                    <Card>
                        <Card.Header>
                            <Card.Title>Contact</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <p>
                                Looking to get in contact? You've got options, and it would be great to hear from you!
                            </p>

                            <ul>
                                <li>
                                    <a target="_blank" rel="noreferrer" href="mailto:admin@nes.science">Email</a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noreferrer" href="https://github.com/igwgames/nes-puzzle-maker-rom/issues">Issue Tracker</a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noreferrer" href="https://discord.gg/cEtyYyZhCc">Community Discord Server</a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noreferrer" href="https://bsky.app/profile/sarahlynne.bsky.social">Developer Bluesky</a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noreferrer" href="https://mastodon.gamedev.place/@SarahLynne">Developer Mastodon</a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noreferrer" href="https://twitter.com/potatolain">Developer Twitter</a>
                                </li>
                            </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default ContactPage;
